import React from "react";
import { createPopper } from "@popperjs/core";
import { MailIcon } from "@heroicons/react/solid";

function ScheduleMessage(props) {
const [color] = React.useState("white")
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start"
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };
  // bg colors
  let bgColor;
  color === "white"
    ? (bgColor = "bg-white")
    : (bgColor = "bg-" + color + "-500");

  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full px-2">
          <div className="w-full">
            <button
              className={
                "flex text-red-500 border text-xs px-5 py-3 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 " +
                bgColor
              }
              type="button"
              ref={btnDropdownRef}
              onClick={() => {
                dropdownPopoverShow
                  ? closeDropdownPopover()
                  : openDropdownPopover();
              }}
            >
              <MailIcon className="w-5 h-5 mr-2" />
              {color === "white" ? "Message Guest" : color + " Dropdown"}
            </button>
            <div
              ref={popoverDropdownRef}
              className={
                (dropdownPopoverShow ? "block " : "hidden ") +
                (color === "white" ? "bg-white " : bgColor + " ") +
                "text-base z-50 float-left py-2 list-none text-left rounded shadow-lg mt-1"
              }
              style={{ minWidth: "12rem" }}
            >
              <a
                href={"mailto:"+props.data.email}
                className={
                  "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent " +
                  (color === "white" ? " text-blueGray-700" : "text-white")
                }
              >
               Email Guest
              </a>
              <a
              target="_blank"
              rel="noopener noreferrer"
                href={"https://api.whatsapp.com/send?phone=234"+props.data.phone.slice(1,11)}
                className={
                  "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent " +
                  (color === "white" ? " text-blueGray-700" : "text-white")
                }
              >
                WhatsApp Guest
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleMessage